module.exports = __webpack_public_path__ + "static/img/S50_c.03178a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/S50_c.png
// module id = vX+j
// module chunks = 0